module.exports = __webpack_public_path__ + "img/三维电子沙盘指挥系统.bb9a6dce.jpg";